export const LOGIN_FLOW = '/authenticating';
export const AUTH0_CALLBACK = '/authorization-code/callback';
export const OKTA_CALLBACK = '/authorization-code/callback';
export const ROOT = '/*';
export const FLOWS = 'flows';
export const SESSIONS = 'sessions';
export const MESSAGES = 'messages';
export const SOLACE_QUEUE_BROWSER = 'solace/queue-browser';
export const SOLACE_LOGS = 'getsolacelog';
export const EXECUTIONS = 'executions';
export const TOOLS_ADD_REMOVE_USERS = 'tools/users/manage';
export const REPORTS_WHO_IS_LOGGED_IN = 'reports/who-is-logged-in';
export const TOOLS_ADD_REMOVE_FIRMS = 'tools/firms/manage';
